<template>
  <pt-detection-package-list class="pt-detection-package-list__withData" :seqTypes="seqTypes"></pt-detection-package-list>
</template>

<script>
import PtDetectionPackageList from './index'
export default {
  name: 'pt-detection-package-list__withData',
  components: {
    'pt-detection-package-list': PtDetectionPackageList
  },
  data () {
    return {
      seqTypes: []
    }
  },
  methods: {
    getSeqTypes () {
      let data = {
        example: { organizationRole: 'LAB' },
        pageableParam: { page: 0, size: 9999, sort: ['createdDate,desc'] }
      }
      this.$store.dispatch('labTestPlatformList', data).then(res => {
        this.seqTypes = res.data.map(e => {
          return {
            value: e.name,
            label: e.name
          }
        })
      }).catch(err => {
        this.$message.error(err)
      })
    }
  },
  created () {
    this.getSeqTypes()
  }
}
</script>
